export { default as PageNotFound } from "./PageNotFound/PageNotFound";
export { default as Footer } from "./Footer/Footer";
export { default as Navbar } from "./Navbar/Navbar";
export { default as Events } from "./Events/Events";
export { default as Resource } from "./Resource/Resource";
export { default as Landing } from "./Landing/Landing";
export { default as About } from "./About/About";
export { default as Team } from "./Team/Team";
export { default as Loader } from "./Loader/Loader";
export { default as Faq } from "./Faq/Faq";
export { default as ContactUs } from "./ContactUs/ContactUs";
